import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import type { UnifiedEvent } from 'src/app/analytics/analyticsEvents';
import { segmentTrack, setShowFamilyModal } from 'src/app/state/actions';
import { getHasMedications, getNumPendingTransfers } from 'src/app/state/selectors';
import type { Dispatch, RootState } from 'src/app/state/store';

import { FamilyModalRenderer } from '.';

const mapStateToProps = (state: RootState) => {
  const { displayModal } = state;
  const { family } = displayModal;
  const { showModal, dependentName } = family;
  const numPendingMeds = getNumPendingTransfers(state);

  const hasNoMedicationHistory = !getHasMedications(state) && numPendingMeds === 0;
  return {
    showModal,
    dependentName,
    hasNoMedicationHistory,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  dispatchModalClosed: (dependentName: string) => {
    dispatch(setShowFamilyModal(false, dependentName));
  },
  dispatchSegmentTrack: (event: UnifiedEvent, payload: any) => dispatch(segmentTrack(event, payload)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PropsFromRedux = ConnectedProps<typeof connector>;

export const FamilyModal = connector(FamilyModalRenderer);
